<script>
	import { onMount } from 'svelte'
	import { fade, fly } from 'svelte/transition'
	import { fromEvent, interval } from 'rxjs'
	import { throttle } from 'rxjs/operators'
	import { gsap } from 'gsap'
	import { ScrollTrigger } from 'gsap/ScrollTrigger'

	gsap.registerPlugin(ScrollTrigger)

	const jq = window.jQuery

	export let featuredProjects
	let activeProject = featuredProjects[0]
	featuredProjects = [...featuredProjects.slice(1), featuredProjects[0]]
	let indicies

	let activeTitle
	let parts
	$: {
		parts = activeProject.post_title.split(' ')
		parts[0] =
			'<span class="featured-letter"><div></div>' +
			parts[0][0] +
			'</span>' +
			parts[0].slice(1)
		activeTitle = parts.join(' ')
	}

	let featImg
	$: if (featImg) featImg.style.backgroundImage = `url(${activeProject.bimg})`

	let owl
	onMount(() => {
		owl = jq('.owl-carousel').owlCarousel({
			dots: false,
			loop: true,
			margin: 16,
			mouseDrag: false,
			nav: false,
			touchDrag: false,
			autoWidth: true,
			responsive: {
				320: {
					margin: 6,
				},
				520: {
					items: 3,
				},
				700: {
					items: 4,
					margin: 16,
				},
				1500: {
					items: 3,
				},
				2100: {
					items: 4,
				},
			},
		})
		indicies = Array.from(
			jq('.owl-item.active').map(
				(_idx, item) => item.querySelector('.decor-img').id
			)
		)

		//TODO last item bug - double
		fromEvent(jq('.decor-img'), 'click')
			.pipe(throttle(ev => interval(50)))
			.subscribe(e => {
				for (let i of [...Array(indicies.indexOf(e.target.id) + 1).keys()]) {
					owl.trigger('next.owl.carousel')
					indicies = Array.from(
						jq('.owl-item.active').map(
							(_idx, item) => item.querySelector('.decor-img').id
						)
					)
				}
			})

		let $homeFeatured = jq('.home-featured')
		if ($homeFeatured.length) {
			let hftl = gsap.timeline({
				scrollTrigger: {
					trigger: '.home-featured',
					start: 'top center', // when the top of the trigger hits the center of the viewport
					// markers: true,
				},
			})
			hftl.fromTo(
				'.home-featured > h2',
				{
					opacity: 0,
					x: 40,
				},
				{
					delay: 0.1,
					duration: 0.5,
					opacity: 1,
					x: 0,
				}
			)
			hftl.fromTo(
				'.home-featured .row',
				{
					opacity: 0,
				},
				{
					delay: 0.1,
					duration: 0.5,
					opacity: 1,
				}
			)
			hftl.fromTo(
				'.home-featured .project-title',
				{
					opacity: 0,
					x: -40,
				},
				{
					delay: 0.1,
					duration: 0.5,
					opacity: 1,
					x: 0,
				}
			)
			hftl.fromTo(
				'.home-featured .home-feat-img-line',
				{
					width: 0,
				},
				{
					delay: 0,
					duration: 2,
					width: '200%',
				}
			)
		}
	})
</script>

<div class="main">
	<div class="home-feat-img section-full">
		{#each featuredProjects as project}
			{#if activeProject.ID == project.ID}
				<div
					transition:fade={{ duration: 650 }}
					class="fillall section-full"
					style={`background-image: url(${activeProject.bimg})`} />
			{/if}
		{/each}
		<div class="home-feat-img-line" />
	</div>
	<div class="row">
		<h3 class="project-title">
			{@html activeTitle}
		</h3>
		<div class="owl-carousel">
			{#each featuredProjects as project}
				<div
					class="decor-img"
					id={project.ID}
					style={`background-image: url(${project.simg})`}
					data-bimg={project.bimg}
					on:click={() => {
						activeProject = project
					}} />
			{/each}
		</div>
	</div>
</div>
